
import {defineComponent} from "vue";
import {ColorChip} from "./models/ColorChip";

export default defineComponent({
    name: 'ColorChips',
    props: {
        id: {
            type: String,
            required: true
        },
        colors: {
            type: Array as () => Array<ColorChip>,
            required: true
        },
        selectedColor: {
            type: String,
            default: null
        },
        isMini: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        isChecked(color: ColorChip): boolean {
            return color.code === this.selectedColor
        },
        onColorChipsChange(color: ColorChip): void {
            this.$emit('change', color);
        }
    }
});
